let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bkNxq")).then(() => parcelRequire('fuuku'));